import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const AlignCenterIcon = ({
  className = '',
  color = bdlGray,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <rect
      fill={color}
      height="1.64062"
      rx="0.820312"
      width="15"
      x="0.5"
      y="2.40625"
    />
    <rect
      fill={color}
      height="1.64062"
      rx="0.820312"
      width="11.25"
      x="2.375"
      y="5.92188"
    />
    <rect
      fill={color}
      height="1.64062"
      rx="0.820312"
      width="7.5"
      x="4.25"
      y="9.4375"
    />
    <rect
      fill={color}
      height="1.64062"
      rx="0.820312"
      width="11.25"
      x="2.375"
      y="12.9531"
    />
  </AccessibleSVG>
);

export default AlignCenterIcon;
